import { Component, ViewChild, ElementRef, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { LlModelsService } from '../ll-models.service';

@Component({
  selector: 'll-loanmgmt-bbc-settings',
  templateUrl: './ll-loanmgmt-bbc-settings.component.html',
  styleUrl: './ll-loanmgmt-bbc-settings.component.css'
})
export class LlLoanmgmtBbcSettingsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('mainDiv_ll_model_collateral_edit_model') mainDiv!: ElementRef;

  bundle = {
    showDisplay: false,
    parentW: 0,
    parentH: 0,
    panelX: 0,
    panelY: 20,
    panelW: 0,
    panelH: 0,
    model: [] as any[],
    permittedUsers: [] as any[],
    emailRoutines: [] as any[],
    BBC_receiveSigned_primary: '',
    BBC_receiveSigned_primary_original: '',
    BBC_receiveSigned_primary_hasChanged: false,
    BBC_receiveSigned_copied: '',
    BBC_receiveSigned_copied_original: '',
    BBC_receiveSigned_copied_hasChanged: false,
    BBC_receiveApproved_primary: '',
    BBC_receiveApproved_primary_original: '',
    BBC_receiveApproved_primary_hasChanged: false,
    BBC_receiveApproved_copied: '',
    BBC_receiveApproved_copied_original: '',
    BBC_receiveApproved_copied_hasChanged: false
  };

  yesNoOptions = ['Yes', 'No'];
  crossAgePctOptions: string[] = Array.from({ length: 71 }, (_, i) => String(30 + i));

  // Modal state
  showRecipientModal = false;
  modalField: string = '';          // e.g. 'BBC_RECEIVESIGNED_PRIMARY'
  modalTitle: string = '';          // e.g. 'Select Recipients for Signed BBC'

  // Removed 'private' → now accessible from template
  selectedContactIds = new Set<string>();


  ineligiblePayerDisplayTypeOptions = [
    { label: 'Inelig.Payer Total', value: 'Payer Total' },
    { label: 'Inelig.Payer GT/LT Age Cap', value: 'AgeCap' }
  ];

  // ── Getters ──

  get bbcIneligiblePayerDisplayType(): string {
    return this.bundle.model?.[0]?.BBC_INELIGIBLEPAYERDISPLAYTYPE || '';
  }

  get bbcIncludeadjustment01YesNo(): string {
    return this.bundle.model?.[0]?.BBC_INCLUDE_ADJUSTMENT_01YESNO || '';
  }
  get bbcIncludeadjustment02YesNo(): string {
    return this.bundle.model?.[0]?.BBC_INCLUDE_ADJUSTMENT_02YESNO || '';
  }
  get bbcIncludeadjustment03YesNo(): string {
    return this.bundle.model?.[0]?.BBC_INCLUDE_ADJUSTMENT_03YESNO || '';
  }
  get bbcIncludeadjustment04YesNo(): string {
    return this.bundle.model?.[0]?.BBC_INCLUDE_ADJUSTMENT_04YESNO || '';
  }
  get bbcIncludeadjustment05YesNo(): string {
    return this.bundle.model?.[0]?.BBC_INCLUDE_ADJUSTMENT_05YESNO || '';
  }
  get bbcAutoBeginLoanBalanceYesNo(): string {
    return this.bundle.model?.[0]?.BBC_AUTOBEGINLOANBALANCEYESNO || '';
  }
  get bbcClientSigRequiredYesNo(): string {
    return this.bundle.model?.[0]?.BBC_CLIENTSIG_REQUIREDYESNO || '';
  }
  get bbcClientSigOnPDFYesNo(): string {
    return this.bundle.model?.[0]?.BBC_CLIENTSIG_ONPDFYESNO || '';
  }
  get bbcClientSigEmailYesNo(): string {
    return this.bundle.model?.[0]?.BBC_CLIENTSIG_EMAILYESNO || '';
  }
  get bbcClientSigEmailAttachmentYesNo(): string {
    return this.bundle.model?.[0]?.BBC_CLIENTSIG_EMAILATTACHYESNO || '';
  }
  get bbcApproveSigRequiredYesNo(): string {
    return this.bundle.model?.[0]?.BBC_APPROVESIG_REQUIREDYESNO || '';
  }
  get bbcApproveSigOnPDFYesNo(): string {
    return this.bundle.model?.[0]?.BBC_APPROVESIG_ONPDFYESNO || '';
  }
  get bbcApproveSigEmailYesNo(): string {
    return this.bundle.model?.[0]?.BBC_APPROVESIG_EMAILYESNO || '';
  }
  get bbcApproveSigEmailAttachmentYesNo(): string {
    return this.bundle.model?.[0]?.BBC_APPROVESIG_EMAILATTACHYESNO || '';
  }
  get bbcIncludeCensusYesNo(): string {
    return this.bundle.model?.[0]?.BBC_INCLUDE_CENSUSYESNO || '';
  }
  get bbcIncludeClassYesNo(): string {
    return this.bundle.model?.[0]?.BBC_INCLUDE_CLASSYESNO || '';
  }
  get bbcIncludeEarnInYesNo(): string {
    return this.bundle.model?.[0]?.BBC_INCLUDE_EARNINYESNO || '';
  }
  get bbcIncludeLocationYesNo(): string {
    return this.bundle.model?.[0]?.BBC_INCLUDE_LOCATIONYESNO || '';
  }
  get bbcIncludePayersYesNo(): string {
    return this.bundle.model?.[0]?.BBC_INCLUDE_PAYERSYESNO || '';
  }
  get bbcIncludeTrueUpYesNo(): string {
    return this.bundle.model?.[0]?.BBC_INCLUDE_TRUEUPYESNO || '';
  }
  get bbcIncludeUnpostedYesNo(): string {
    return this.bundle.model?.[0]?.BBC_INCLUDE_UNPOSTEDYESNO || '';
  }
  get bbcIncludePageOneLocListYesNo(): string {
    return this.bundle.model?.[0]?.BBC_INCLUDE_PAGEONELOCLISTYESNO || '';
  }

  get bbcDueReminderYesNo(): string {
    return this.bundle.model?.[0]?.BBC_DUEREMINDERYESNO || '';
  }

  get bbcSystemEmailRoutineIdReminder(): string | number | null {
    return this.bundle.model?.[0]?.BBC_SYSTEMEMAILROUTINEID_REMINDER ?? null;
  }

  get bbcSystemEmailRoutineIdLateNotice(): string | number | null {
    return this.bundle.model?.[0]?.BBC_SYSTEMEMAILROUTINEID_LATENOTICE ?? null;
  }


  recipientsDisplay(fieldName: string): string {
    const idsStr = this.bundle.model?.[0]?.[fieldName] || '';
    if (!idsStr.trim()) return 'No recipients configured';

    const contactIds = idsStr.split(',').map(id => id.trim()).filter(Boolean);

    const emails: string[] = contactIds
      .map(id => {
        const user = this.bundle.permittedUsers.find(u => String(u.CONTACTID) === id);
        return user?.CONTACTEMAIL?.trim() || '';
      })
      .filter(Boolean);

    return emails.length > 0 ? emails.join('; ') : 'No valid recipients found';
  }

  // ── Modal handlers ──
  openRecipientsModal(fieldName: string, title: string): void {
    this.modalField = fieldName;
    this.modalTitle = title;

    const currentIdsStr = this.bundle.model?.[0]?.[fieldName] || '';
    this.selectedContactIds.clear();
    if (currentIdsStr.trim()) {
      currentIdsStr.split(',').map(id => id.trim()).filter(Boolean).forEach(id => {
        this.selectedContactIds.add(id);
      });
    }

    this.showRecipientModal = true;
  }

  toggleContact(contactId: string | number): void {
    const idStr = String(contactId);

    if (this.selectedContactIds.has(idStr)) {
      this.selectedContactIds.delete(idStr);
    } else {
      this.selectedContactIds.add(idStr);
    }

    const updatedIds = Array.from(this.selectedContactIds).join(',');
    if (this.bundle.model?.[0]) {
      this.bundle.model[0][this.modalField] = updatedIds;
    }

    this.saveFieldChange(this.modalField, updatedIds);
  }

  closeModal(): void {
    this.showRecipientModal = false;
    this.modalField = '';
    this.modalTitle = '';
    this.selectedContactIds.clear();
  }

  isContactSelected(contactId: any): boolean {
    return this.selectedContactIds.has(String(contactId));
  }

  // ── Change handlers (for legacy input fields) ──
  BBC_receiveSigned_primary_change(newValue: string): void {
    this.bundle.BBC_receiveSigned_primary = newValue;
    this.bundle.BBC_receiveSigned_primary_hasChanged =
      this.bundle.BBC_receiveSigned_primary !== this.bundle.BBC_receiveSigned_primary_original;
  }
  BBC_receiveSigned_primary_save(): void {
    this.onChanged('BBC_RECEIVESIGNED_PRIMARY', this.bundle.BBC_receiveSigned_primary);
    this.bundle.BBC_receiveSigned_primary_original = this.bundle.BBC_receiveSigned_primary;
    this.bundle.BBC_receiveSigned_primary_hasChanged = false;
  }

  BBC_receiveSigned_copied_change(newValue: string): void {
    this.bundle.BBC_receiveSigned_copied = newValue;
    this.bundle.BBC_receiveSigned_copied_hasChanged =
      this.bundle.BBC_receiveSigned_copied !== this.bundle.BBC_receiveSigned_copied_original;
  }
  BBC_receiveSigned_copied_save(): void {
    this.onChanged('BBC_RECEIVESIGNED_COPIED', this.bundle.BBC_receiveSigned_copied);
    this.bundle.BBC_receiveSigned_copied_original = this.bundle.BBC_receiveSigned_copied;
    this.bundle.BBC_receiveSigned_copied_hasChanged = false;
  }

  BBC_receiveApproved_primary_change(newValue: string): void {
    this.bundle.BBC_receiveApproved_primary = newValue;
    this.bundle.BBC_receiveApproved_primary_hasChanged =
      this.bundle.BBC_receiveApproved_primary !== this.bundle.BBC_receiveApproved_primary_original;
  }
  BBC_receiveApproved_primary_save(): void {
    this.onChanged('BBC_RECEIVEAPPROVED_PRIMARY', this.bundle.BBC_receiveApproved_primary);
    this.bundle.BBC_receiveApproved_primary_original = this.bundle.BBC_receiveApproved_primary;
    this.bundle.BBC_receiveApproved_primary_hasChanged = false;
  }

  BBC_receiveApproved_copied_change(newValue: string): void {
    this.bundle.BBC_receiveApproved_copied = newValue;
    this.bundle.BBC_receiveApproved_copied_hasChanged =
      this.bundle.BBC_receiveApproved_copied !== this.bundle.BBC_receiveApproved_copied_original;
  }
  BBC_receiveApproved_copied_save(): void {
    this.onChanged('BBC_RECEIVEAPPROVED_COPIED', this.bundle.BBC_receiveApproved_copied);
    this.bundle.BBC_receiveApproved_copied_original = this.bundle.BBC_receiveApproved_copied;
    this.bundle.BBC_receiveApproved_copied_hasChanged = false;
  }

  // ── Centralized save ──
  private saveFieldChange(fieldName: string, newValue: string): void {
    this.LlModelsService.NG_LL_company_model_edit(fieldName, newValue);
    console.log(`Saved field ${fieldName} = ${newValue}`);
  }

  setModelValue(fieldName: string, value: string): void {
    if (this.bundle.model?.[0]) {
      this.bundle.model[0][fieldName] = value;
    }
  }

  onChanged(fieldName: string, newValue: string): void {

    console.log(fieldName)
    console.log("newValue: " + newValue)

    this.setModelValue(fieldName, newValue);
    this.saveFieldChange(fieldName, newValue);
  }



  constructor(private LlModelsService: LlModelsService) { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.setVars();
  }

  ngOnDestroy(): void { }

  setVars() {
    if (!this.mainDiv?.nativeElement?.parentElement?.parentElement) return;
    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;
    setTimeout(() => {
      this.bundle.panelW = this.bundle.parentW;
      this.bundle.panelH = this.bundle.parentH - this.bundle.panelY;
      this.getData();
    }, 0);
  }

  getData() {
    this.LlModelsService.NG_LL_company_model_get((arr: any[]) => {
      console.log('Model data loaded:', arr);
      this.bundle.model = arr || [];
      this.bundle.showDisplay = true;

      // Initialize working copies (for legacy input fields)
      this.bundle.BBC_receiveSigned_primary_original = this.bundle.model?.[0]?.BBC_RECEIVESIGNED_PRIMARY || '';
      this.bundle.BBC_receiveSigned_primary = this.bundle.BBC_receiveSigned_primary_original;
      this.bundle.BBC_receiveSigned_copied_original = this.bundle.model?.[0]?.BBC_RECEIVESIGNED_COPIED || '';
      this.bundle.BBC_receiveSigned_copied = this.bundle.BBC_receiveSigned_copied_original;
      this.bundle.BBC_receiveApproved_primary_original = this.bundle.model?.[0]?.BBC_RECEIVEAPPROVED_PRIMARY || '';
      this.bundle.BBC_receiveApproved_primary = this.bundle.BBC_receiveApproved_primary_original;
      this.bundle.BBC_receiveApproved_copied_original = this.bundle.model?.[0]?.BBC_RECEIVEAPPROVED_COPIED || '';
      this.bundle.BBC_receiveApproved_copied = this.bundle.BBC_receiveApproved_copied_original;

      this.LlModelsService.NG_LL_company_model_permited_get((arr: any[]) => {
        this.bundle.permittedUsers = arr;

        this.LlModelsService.NG_LL_company_models_emailRoutines_get((arr02: any[]) => {
          this.bundle.emailRoutines = arr02;
        });
      });
    });
  }
}
